import React, { useEffect, useState } from 'react'
import AssessmentModule from '../AssesmentModule/AssesmentModule'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AlertSaveButton from '../../../button/AlertSaveButton'
import { updateClassDialog, updateClassForm } from '../../../../store/actions/class.actions'
import Module from '../../../layout/Module'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'
import useYears from '../../../../hooks/setting/useYears'
import useSubjects from '../../../../hooks/subjects/useSubjects'
import DialogAction from './Dialog/Dialog'
import List from './List/List'
import Edit from './Edit/Edit'
import DialogPreview from './DialogPreview/DialogPreview'
import Preview from './Preview/Preview'
import Create from './Create/Create'
import MarkingClasses from './MarkingClasses/MarkingClasses'
import SelectCurriculum from '../../../SelectCurriculum/SelectCurriculum'

const Classes = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const curriculumId = params['*']?.split('/')[0]
  const redirectStudentId = params.studentId ? `${params.studentId}/` : ''
  const permissions = useSelector((state) => state?.session?.permissions?.class || {})
  const dialog = useSelector((state) => state?.class?.dialog)
  const dialogOpen = useSelector((state) => state?.class?.dialog?.open)
  const preview = useSelector((state) => state?.class?.preview || null)
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );

  const [view, setView] = useState('grid')
  const { getYears } = useYears()
  const { getAllSubjects } = useSubjects();
  const onRedirect = (redirectTo) => {
    const newCurriculumId = ['unassigned', 'assigned', 'all'].includes(curriculumId) ? curriculumId : 'all';
    navigate(`/dashboard/${redirectStudentId}classes/${newCurriculumId}${redirectTo}`)
  }

  useEffect(() => {
    getYears()
  }, [])
  useEffect(() => {
    getAllSubjects(curriculumId)
  }, [curriculumId])

  return (
    <AssessmentModule
      title="Classes"
      moduleName='class'
      titleLink={`/dashboard/${redirectStudentId}classes`}
      actions={<>
        { curriculumId && (
          <AlertSaveButton
            submodule='Classes'
            icon='th-large'
            title='Grid'
            color='secondary'
            onDontSave={() => {
              onRedirect('')
              setView('grid')
            }}
          />
        )}
        { curriculumId && (
          <AlertSaveButton
            submodule='Classes'
            icon='th-list'
            title='List'
            color='secondary'
            onDontSave={() => {
              onRedirect('')
              setView('table')
            }}
          />
        )}
        { permissions?.created && curriculumId && existLinceseAssessment && (
          <AlertSaveButton
            submodule='Classes'
            icon='plus'
            title='Create'
            color='secondary'
            onDontSave={() => {
              onRedirect('/create/step/0')
              dispatch(updateClassForm({ curriculumId: curriculumId, teachers: [], students: [] }))
            }}
          />
        )}
      </>}
    >
      <Routes>
        <Route path="/" element={<SelectCurriculum />} />
        <Route index path="/:curriculumId" element={<List view={view} />} />
        <Route path="/:curriculumId/create/step/:step" element={<Create /> } />
        <Route path="/:curriculumId/edit/:id/step/:step" element={<Edit /> } />
        <Route path="/:curriculumId/preview/:classId" element={<Preview curriculumId={curriculumId} />} />
        <Route path="/:curriculumId/preview/:classId/unit-of-learning/:ulId/*" Component={MarkingClasses} />
        <Route
          path='*'
          element={
            <Module.BodyFullContainer className='flex justify-center items-center'>
              <NotFoundPage />
            </Module.BodyFullContainer>
          } 
        />
      </Routes>
      { dialogOpen && 
        <DialogAction
          show={dialogOpen}
          onClose={() => dispatch(updateClassDialog())}
          type={dialog.type}
          formData={dialog.form}
          paramsCurriculumId={curriculumId}
        />
      }
      { preview && <DialogPreview curriculumId={curriculumId} /> }
    </AssessmentModule>
  )
}

export default Classes